import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { salesPrimaryBlockDefaultStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/Sales/constants";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { PricingBlock } from "../../../constants/BlockCategories";
import { PricingBlock1 as Block } from "./PricingBlock1";
import { defaultData } from "./PricingBlock1DefaultData";
import imagePreview from "./pricing_block_1_preview.png";

export const PricingBlock1: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Pricing Block 1",
    nameI18n: "builder_ui.block_type.pricing.block_1",
    version: 1,
    category: [PricingBlock],
    props: {
      header: {
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      footer: {
        name: "Footer",
        nameI18n: "builder_ui.prop_type.footer",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            defaultValue: salesPrimaryBlockDefaultStyles.backgroundColor,
            category: [DesignProp, GeneralProp],
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            defaultValue: salesPrimaryBlockDefaultStyles.padding,
            category: [DesignProp, PaddingsProp],
          },
          margin: {
            ...margin,
            defaultValue: salesPrimaryBlockDefaultStyles.margin,
            category: [DesignProp, MarginsProp],
          },
        },
        type: "styles",
      },
    },
  },
};
